import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";

import HttpManager from "../../../services/HttpManager";
import { ProspectCatalogs } from "../../../services/v2/prospects.service";
import { errorTexto, nombreCompleto } from "./salesHelpers";

interface Props {
	campusId: number;
	catalogs: ProspectCatalogs | null;
	onClose: () => void;
	onCreated: (id: number) => void;
	onOpenExisting: (id: number) => void;
}

/*
	Alta manual (Esteban, 2026-09-19): empieza por el TELÉFONO, no por el nombre — con casi un millón
	de teléfonos cargados, primero se revisa si ya existe. Obligatorios solo cuatro.
	Identificación, dirección y nivel educativo se piden al matricular, no aquí.
*/
const NewProspectModal: React.FC<Props> = ({ campusId, catalogs, onClose, onCreated, onOpenExisting }) => {
	const http = HttpManager.getInstance();
	const [phone, setPhone] = useState<string>("");
	const [lookup, setLookup] = useState<{ valid: boolean; phone: string | null; match: any } | null>(null);
	const [f, setF] = useState<any>({ firstName: "", lastName: "", courseInterest: "", campusId, sourceId: "", adName: "", phoneAlt: "", note: "" });
	const [busy, setBusy] = useState<boolean>(false);
	const [error, setError] = useState<string | null>(null);
	const timer = useRef<any>(null);

	useEffect(() => {
		clearTimeout(timer.current);
		const digits = phone.replace(/\D/g, "");
		if (digits.length < 8) { setLookup(null); return; }
		timer.current = setTimeout(async () => {
			try { setLookup((await http.prospectsService.lookupPhone(campusId, phone)).data); }
			catch (e) { setLookup(null); }
		}, 350);
		return () => clearTimeout(timer.current);
	}, [phone]);

	const set = (k: string) => (e: any) => setF({ ...f, [k]: e.target.value });
	const puede = lookup?.valid && !lookup.match && f.firstName.trim() && f.courseInterest.trim() && f.campusId;

	const guardar = async () => {
		setBusy(true); setError(null);
		try {
			const r = await http.prospectsService.create(campusId, { ...f, phone, sourceId: f.sourceId || null });
			onCreated(r.data.prospect.id);
		} catch (e) { setError(errorTexto(e)); }
		finally { setBusy(false); }
	};

	return (
		<Modal show onHide={onClose} size="lg" className="ventas-nuevo-modal">
			<Modal.Header closeButton><Modal.Title style={{ fontFamily: "Bricolage, sans-serif", fontWeight: 800 }}>Nuevo prospecto</Modal.Title></Modal.Header>
			<Modal.Body style={{ display: "flex", flexDirection: "column", gap: 16 }}>
				<div>
					<label htmlFor="np-tel">Teléfono</label>
					<input id="np-tel" type="tel" autoFocus value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="+504 9999 9999 o 81 1234 5678" style={{ fontSize: 17, fontWeight: 600 }} />
					{lookup && !lookup.valid ? <div className="aviso" style={{ marginTop: 8 }}>Ese número no parece válido.</div> : null}
					{lookup?.match ? (
						<div className="existe" style={{ marginTop: 8, display: "flex", gap: 12, alignItems: "center" }}>
							<div style={{ flex: 1 }}>
								<div><b>Ya existe:</b> {nombreCompleto(lookup.match)}</div>
								<div style={{ color: "var(--wa-apagado)" }}>{[lookup.match.etapa, lookup.match.status, lookup.match.team_code, lookup.match.owner_zoho_name].filter(Boolean).join(" · ")} · {lookup.match.events_count} eventos</div>
							</div>
							<button className="btn-wa pri" onClick={() => onOpenExisting(lookup.match.id)}>Abrir</button>
						</div>
					) : null}
				</div>

				<fieldset disabled={!lookup?.valid || !!lookup?.match} style={{ display: "flex", flexDirection: "column", gap: 14, opacity: !lookup?.valid || lookup?.match ? .5 : 1 }}>
					<div className="rejilla">
						<div><label htmlFor="np-nom">Nombre</label><input id="np-nom" value={f.firstName} onChange={set("firstName")} /></div>
						<div><label htmlFor="np-ape">Apellidos</label><input id="np-ape" value={f.lastName} onChange={set("lastName")} /></div>
						<div><label htmlFor="np-cur">Curso de interés</label><input id="np-cur" value={f.courseInterest} onChange={set("courseInterest")} placeholder="Repostería, Barbería, Inglés…" /></div>
						<div>
							<label htmlFor="np-pla">Plantel</label>
							<select id="np-pla" value={f.campusId} onChange={set("campusId")}>
								{(catalogs?.campuses || []).map((c) => <option key={c.id} value={c.id}>{c.name.replace("Washington Academy ", "")}</option>)}
							</select>
						</div>
						<div>
							<label htmlFor="np-src">Cómo nos encontró</label>
							<select id="np-src" value={f.sourceId} onChange={set("sourceId")}>
								<option value="">—</option>
								{(catalogs?.sources || []).map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
							</select>
						</div>
						<div><label htmlFor="np-anu">Anuncio</label><input id="np-anu" value={f.adName} onChange={set("adName")} placeholder="opcional" /></div>
						<div><label htmlFor="np-tel2">Segundo teléfono</label><input id="np-tel2" type="tel" value={f.phoneAlt} onChange={set("phoneAlt")} placeholder="opcional" /></div>
					</div>
					<div><label htmlFor="np-nota">Nota inicial</label><textarea id="np-nota" rows={2} value={f.note} onChange={set("note")} placeholder="Qué dijo, qué pidió" /></div>
				</fieldset>
				{error ? <div className="aviso error">{error}</div> : null}
			</Modal.Body>
			<Modal.Footer>
				<button className="btn-wa" onClick={onClose}>Cancelar</button>
				<button className="btn-wa pri" disabled={!puede || busy} onClick={guardar}>Guardar y abrir</button>
			</Modal.Footer>
		</Modal>
	);
};

export default NewProspectModal;
